import { Directive, HostListener } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: 'form[formGroup]',
  standalone: true,
})
export class AutoDirtyDirective {
  constructor(private formGroupDir: FormGroupDirective) {}

  @HostListener('submit')
  onFormSubmit() {
    const formGroup = this.formGroupDir.control;
    this.markAllControlsAsDirty(formGroup);
  }

  private markAllControlsAsDirty(formGroup: any) {
    Object.values(formGroup.controls).forEach((control: any) => {
      if (control.controls) {
        this.markAllControlsAsDirty(control);
      } else {
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
      }
    });
  }
}
